export type SiteLocale = 'en' | 'pl';

export function resolveSiteLocale(pathname: string, preferredLanguage?: string): SiteLocale {
    const match = pathname.match(/^\/(en|pl)(?:\/|$)/i);
    if (match) return match[1].toLowerCase() as SiteLocale;
    return (preferredLanguage || navigator.language).toLowerCase().startsWith('pl') ? 'pl' : 'en';
}

export function localizePath(path: string, locale: string): string {
    // Only allow internal destinations, including login return URLs.
    if (/^(?:[a-z][a-z\d+.-]*:|\/\/)/i.test(path) || path.includes('\\')) {
        return `/${locale}/home`;
    }
    const normalized = path.startsWith('/') ? path : `/${path}`;
    const unprefixed = normalized.replace(/^\/(en|pl)(?=\/|\?|#|$)/i, '');
    const canonical = unprefixed.replace(/^\/find(?=\/|\?|#|$)/, '/finder');
    return `/${locale}${canonical === '/' ? '' : canonical}`;
}
